import { MapperBase } from "src/app/utilities/mapper-base";
import { Enumeration } from "../enumeration.model";
import { UploadBatchProductionReport } from "@models/ui/upload-batch-production-report.model";
import { UploadBatchProductionReportResource } from "@models/resource/upload-batch-production-report.resource";
import { UploadBatchProductionValidationReportResourceToUploadBatchProductionValidationReportMapper } from "./upload-batch-production-validation-report-resource-to-upload-batch-production-validation-report.mapper";

const mapper = new UploadBatchProductionValidationReportResourceToUploadBatchProductionValidationReportMapper();
export class UploadBatchProductionReportResourceToUploadBatchProductionReportMapper extends MapperBase<UploadBatchProductionReportResource, UploadBatchProductionReport> {
    map(source: UploadBatchProductionReportResource): UploadBatchProductionReport {
        const dest = new UploadBatchProductionReport();
                dest.caseTitle = source.caseTitle;
                dest.custodian = source.custodian;
                dest.docSource = source.docSource;
                dest.validationStatus = source.validationStatus;
                if(source.reportData){
                    dest.validationData = mapper.map(source.reportData);
                    dest.docCount = source.reportData.totalDocCount;
                    dest.totalPageCount = source.reportData.totalPageCount;
                }
                dest.uploadBatchId = source.uploadBatchId;
                dest.uploadBatchTitle = source.uploadBatchTitle;
                dest.uploadBatchType = new Enumeration(source.uploadBatchType.value, source.uploadBatchType.displayName);
                dest.uploadedTimestamp = source.uploadedTimestamp; 
                dest.userEmail = source.userEmail;
                dest.timezone = source.utcOffset;
                return dest;
    }
}